import React, { useMemo } from "react";
import { Typography, Box } from "@mui/material";
import { TouchApp } from "@mui/icons-material";

import { INVITATION_OCCASION, Invitations } from "../../../../../store/services/invitations/dto/invitations.dto";
import { NamesEntranceWrapper } from "./styles";
import { LANG_AR, LANG_EN, RTL } from "../../../../../Components/Templates/WeddingTemplates/constants";
import langEN from "../../../../../Components/Templates/WeddingTemplates/lang.EN.json";
import langAR from "../../../../../Components/Templates/WeddingTemplates/lang.AR.json";
import { TemplateColorObject } from "../../../../../InvitationColorMatrix";

const NamesEntrance = ({
	isOpened,
	setIsOpened,
	selectedInvitation,
	colorMatrix,
	preview
}: {
	isOpened: boolean;
	setIsOpened: React.Dispatch<React.SetStateAction<boolean>>;
	selectedInvitation: Invitations;
	colorMatrix: TemplateColorObject;
	preview?: boolean;
}) => {
	const lang = selectedInvitation?.language === LANG_EN ? langEN : langAR;

	const invitationType = useMemo(() => {
		if (!selectedInvitation) return;
		switch (selectedInvitation?.occasion) {
			case INVITATION_OCCASION.KATB_KTAB: {
				return lang.the_katb_ktab_of;
			}
			case INVITATION_OCCASION.ENGAGEMENT: {
				return lang.the_engagement_of;
			}
			default: {
				return lang.the_wedding_of;
			}
		}
	}, [selectedInvitation]);

	return (
		<NamesEntranceWrapper
			className={`${isOpened ? "hide opened" : "show"} ${preview ? "preview" : ""}`}
			onClick={() => setIsOpened(true)}
			colormatrix={colorMatrix}
		>
			<div className={`couples_banner ${selectedInvitation?.language === LANG_AR && RTL}`}>
				<Typography className={"wedding_of"}>{invitationType}</Typography>
				<Typography className={"couples groom"}>{selectedInvitation?.groom_name}</Typography>
				<Typography className={"couples and"}>{lang.and}</Typography>
				<Typography className={"couples bride"}>{selectedInvitation?.bride_name}</Typography>
			</div>

			<Box className={"tab_continue_container"} display={"flex"} flexDirection={"column"}>
				<Box
					className={`tab_continue ${isOpened ? "animate__animated animate__fadeOut" : "animate__animated animate__headShake animate__delay-4s animate__infinite"}`}
				>
					<TouchApp />
				</Box>
				<Typography className={`tab_continue_text ${isOpened ? "animate__animated animate__fadeOut" : ""}`}>
					{lang.TAP_TO_CONTINUE}
				</Typography>
			</Box>
		</NamesEntranceWrapper>
	);
};

export default NamesEntrance;
